module.exports = __webpack_public_path__ + "img/SES_205428809.2aa52b4b.jpg";